import { PMNModele, PMNModele_Input } from '@/domain/PMNModele'
import routeMixin from '@/router/routeMixin'
import mixins from 'vue-typed-mixins'
import globalMixin from '../../globalMixin'
import _ from 'lodash'
import { PMNDemande, PMNDemande_Produit, PMNDemande_ProduitExtanded, PMNDemande_Reponse } from '@/domain/PMNDemande'
import Openable from '@/global/viewmodels/openable'
import Vue from 'vue'
import mobileTypeMixin from '@/global/mobile/mobileTypeMixin'

export default mixins(routeMixin, globalMixin, mobileTypeMixin).extend({
    data: function() {
        return {
            demandeSignature: null as null | PMNDemande,
            dialog: new Openable(),
            modelesDisponibles: [] as PMNModele[],
            demandesPMN: [] as PMNDemande[],
            PMNDemandeEditee: null as null | PMNDemande,
            PMNDemandeModeleUtilise: null as null | PMNModele,
            produitAjoute: null as null | number
        }
    },
    methods: {
        checkReponses: function() {
            if (!this.PMNDemandeEditee) return

            const reponsesManquantes = [] as string[]
            for (const rep of this.PMNDemandeEditee.reponses) {
                if (!rep.reponse) {
                    const question = this.dicInput[rep.pmnModele_InputId]
                    reponsesManquantes.push(`${question.label} non répondue`)
                }
            }

            if (this.PMNDemandeEditee.produits.length == 0) reponsesManquantes.push('Aucune produit sélectionné')

            return reponsesManquantes
        },
        downloadPMNRemisee(typePMN: number){
            this.$http
                    .api(`PMNBiobank/get-url-modele-PMN-remise-client?typeFichier=${typePMN}`)
                    .get()
                    .then(x => {
                        window.location.href = this.$http.baseUrl + `/PMNBiobank/get-modele-PMN-remise?token=${x.data}`
                    })
                    .catch(x => this.$swal.toast.errorApi(x))
                    .finally(() => this.$loader.stop())
        },
        getModelesDisponibles: function() {
            this.$loader.go()
            this.$http
                .api(`PMNClient/all-modeles`)
                .get()
                .then(x => {
                    this.modelesDisponibles = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        getAllDemandePMN() {
            this.$loader.go()
            this.$http
                .api(`PMNClient/all`)
                .get()
                .then(x => {
                    this.demandesPMN = x.data
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        createNewPMN(modele: PMNModele) {
            this.PMNDemandeEditee = new PMNDemande()
            this.PMNDemandeEditee.pmnModeleId = modele.id
            this.PMNDemandeModeleUtilise = modele
            this.PMNDemandeEditee.reponses = _.map(modele.inputs, a => {
                const reponse = new PMNDemande_Reponse()
                reponse.pmnModele_InputId = a.id 

                return reponse
            })
        },
        editDemandePMN(demande: PMNDemande) {
            this.PMNDemandeEditee = demande
            this.PMNDemandeModeleUtilise = _.find(this.modelesDisponibles, modele => modele.id == demande.pmnModeleId) || null
        },
        save(withEnvoi: boolean) {
            if (!this.PMNDemandeEditee) return

            if (withEnvoi) {
                const reponsesManquantes = this.checkReponses()
                if (reponsesManquantes?.length) {
                    this.$loader.stop()
                    return this.$swal.toast.error(reponsesManquantes.join('\n'))
                }
            }
            this.$loader.go()
            this.$http
                .api(`PMNClient`)
                .post(this.PMNDemandeEditee)
                .then(res => {
                    this.PMNDemandeEditee = null
                    this.PMNDemandeModeleUtilise = null
                    this.getAllDemandePMN()
                    if (withEnvoi) {
                        this.$swal.confirm.yesCancel('Envoi de la PMN', 'Voulez-vous envoyer la PMN ?', 'Oui').then(a => {
                            if (a.isConfirmed) {
                                const demande = this.demandesPMN.find(d => d.id == res.data)
                                if (demande) this.envoyerDemande(demande)
                            }
                        })
                    }
                })
                .catch(x => this.$swal.toast.errorApi(x))
                .finally(() => this.$loader.stop())
        },
        cancel() {
            this.PMNDemandeEditee = null
            this.PMNDemandeModeleUtilise = null

            this.getAllDemandePMN()
        },
        envoyerDemande(demande: PMNDemande) {
            this.demandeSignature = demande
            this.signature()
        },
        signature() {
            this.dialog.open()
            const that = this

            Vue.nextTick(() => {
                const canvas = this.$refs.signature as HTMLCanvasElement

                // get canvas 2D context and set him correct size
                const ctx = canvas.getContext('2d')

                // last known position
                const pos = { x: 0, y: 0 }

                // new position from mouse event
                function setPosition(e: MouseEvent | TouchEvent) {
                    if (e instanceof MouseEvent) {
                        pos.x = e.clientX - (window.pageXOffset + canvas.getBoundingClientRect().left)
                        pos.y = e.clientY - (window.pageYOffset + canvas.getBoundingClientRect().top)
                    } else {
                        console.log()
                        pos.x = e.changedTouches[0].clientX - (window.pageXOffset + canvas.getBoundingClientRect().left)
                        pos.y = e.changedTouches[0].clientY - (window.pageYOffset + canvas.getBoundingClientRect().top)
                    }
                }

                // resize canvas
                function resize() {
                    if (!ctx) return
                    ctx.canvas.width = that.widthCanvas()
                    ctx.canvas.height = that.heightCanvas()
                }

                function draw(e: MouseEvent | TouchEvent) {
                    if (!ctx) return
                    // mouse left button must be pressed
                    if (e instanceof MouseEvent && e.buttons !== 1) return

                    ctx.beginPath() // begin

                    ctx.lineWidth = 5
                    ctx.lineCap = 'round'
                    ctx.strokeStyle = '#c0392b'

                    ctx.moveTo(pos.x, pos.y) // from
                    setPosition(e)
                    ctx.lineTo(pos.x, pos.y) // to

                    ctx.stroke() // draw it!
                }

                resize()

                window.addEventListener('resize', resize)
                canvas.addEventListener('mousemove', draw)
                canvas.addEventListener('mousedown', setPosition)
                canvas.addEventListener('mouseenter', setPosition)
                canvas.addEventListener('touchmove', draw)
                canvas.addEventListener('touchstart', setPosition)
                canvas.addEventListener('touchend', setPosition)
            })
        },
        addProduit() {
            if (!this.PMNDemandeModeleUtilise || !this.PMNDemandeEditee || !this.produitAjoute) return

            const produit = _.find(this.PMNDemandeModeleUtilise.produitsProposes, p => p.id == this.produitAjoute)
            if (!produit) return

            const produitToAdd = new PMNDemande_Produit()
            produitToAdd.produitProposeId = produit.id
            produitToAdd.quantite = 1
            this.PMNDemandeEditee.produits.push(produitToAdd)

            Vue.nextTick(() => {
                this.produitAjoute = null
            })
        },
        addMoreProduct(produit: PMNDemande_ProduitExtanded) {
            if (!this.PMNDemandeEditee) return
            const product = _.find(this.PMNDemandeEditee.produits, p => p.produitProposeId == produit.produitProposeId)
            if (product) product.quantite += 1
        },
        removeSomeProduct(produit: PMNDemande_ProduitExtanded) {
            if (!this.PMNDemandeEditee) return
            const product = _.find(this.PMNDemandeEditee.produits, p => p.produitProposeId == produit.produitProposeId)
            if (product && product.quantite > 1) product.quantite -= 1
        },
        deleteProduct(produit: PMNDemande_ProduitExtanded) {
            if (!this.PMNDemandeEditee) return
            const productIndex = _.findIndex(this.PMNDemandeEditee.produits, p => p.produitProposeId == produit.produitProposeId)
            if (productIndex != -1) this.PMNDemandeEditee.produits.splice(productIndex, 1)
        },
        isAvailable(typePmn: number){
            return this.$database.account.listePMNAutorisees.indexOf(typePmn) !== -1
        },
        anyAvailable(){
            return this.$database.account.listePMNAutorisees.length !== 0
        },
    },
    computed: {
        total: function(): number {
            if (!this.PMNDemandeEditee) return 0

            let total = 0
            for (const produit of this.PMNDemandeEditee.produits) {
                const produitPropose = _.find(this.PMNDemandeModeleUtilise?.produitsProposes, p => p.id == produit.produitProposeId)
                if (!produitPropose) continue

                total += produit.quantite * produitPropose.prix
            }

            return total
        },
        dicInput: function(): _.NumericDictionary<PMNModele_Input> {
            if (!this.PMNDemandeModeleUtilise) return {}

            return _.chain(this.PMNDemandeModeleUtilise.inputs)
                .keyBy(a => a.id)
                .value()
        },
        dicReponses: function(): _.NumericDictionary<PMNDemande_Reponse> {
            if (!this.PMNDemandeEditee) return {}

            return _.chain(this.PMNDemandeEditee.reponses)
                .keyBy(a => a.pmnModele_InputId)
                .value()
        },
        modelesDisponiblesCreation(): PMNModele[] {
            return _.filter(this.modelesDisponibles, modele => modele.version == null && this.isAvailable(modele.type))
        },
        produitsDemandes(): (PMNDemande_ProduitExtanded | null)[] {
            if (!this.PMNDemandeEditee || !this.PMNDemandeModeleUtilise) return []

            return _.chain(this.PMNDemandeEditee.produits)
                .map(produit => {
                    const produitPropose = _.find(this.PMNDemandeModeleUtilise?.produitsProposes, p => p.id == produit.produitProposeId)
                    if (!produitPropose) return null

                    const produitReturn = new PMNDemande_ProduitExtanded()
                    produitReturn.produitProposeId = produit.produitProposeId
                    produitReturn.quantite = produit.quantite
                    produitReturn.prix = produitPropose.prix
                    produitReturn.libelleArticle = produitPropose.nom
                    produitReturn.codeArticle = produitPropose.codeArticle

                    return produitReturn
                })
                .filter(p => p !== null)
                .value()
        },
        produitsDisponibles(): { text: string; value: number }[] {
            if (!this.PMNDemandeModeleUtilise || !this.PMNDemandeEditee) return []

            const groupementsProduits = _.chain(this.PMNDemandeModeleUtilise.produitsProposes)
                .groupBy('codeFamille')
                .map((values, key) => ({ codeFamille: key, produits: values }))
                .value()

            const res = [] as any[]
            for (const groupementProduit of groupementsProduits) {
                if (_.some(res)) res.push({ divider: true })

                res.push({ header: groupementProduit.produits[0].libelleFamille })
                res.push(..._.map(groupementProduit.produits, p => ({ text: p.nom, value: p.id })))
            }

            return _.filter(res, produitPropose => !_.some(this.PMNDemandeEditee?.produits, p => p.produitProposeId == produitPropose.value))
        }
    },
    mounted: function() {
        this.getModelesDisponibles()
        this.getAllDemandePMN()
    }
})
